<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f011-01.jpg" width="80%"/></p>
<p class="caption">Roche Abbey was built in a woodland clearing on the boundary between Maltby and Hooton Levitt. The ruined transepts date from the 1170s and still reach to their full height.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 15_chapter021.vue?122adf95